import { render, staticRenderFns } from "./ProblemasMaisAtendidos.vue?vue&type=template&id=514d655c&scoped=true&"
import script from "./ProblemasMaisAtendidos.vue?vue&type=script&lang=js&"
export * from "./ProblemasMaisAtendidos.vue?vue&type=script&lang=js&"
import style0 from "./ProblemasMaisAtendidos.vue?vue&type=style&index=0&id=514d655c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514d655c",
  null
  
)

export default component.exports